/* 单词页面 */
/*  Author: wanfengren */
/* create: 2018/11/12*/
/* modified: 2019/09/06 新增页面埋点*/
<template>
  <div class="container">
    <div class="container_body">
        <div class="header-panel">
          <div class="headertitle">{{Data.word_name}}</div>
        </div>

        <div class="resource intro" v-if="Data.tips">
          <div v-html="addDiv(Data.tips)"></div>
        </div>

        <div id="desc">
          <div class="resource intro">
            <div class="dic-basic-voice">
             <p>
               <!-- 逻辑：包含对应发音才展现音标 -->
              <div v-if="Data.ph_en_mp3 || Data.ph_am_mp3">
                <span v-if="Data.ph_en_mp3">
                  <span class="word_ph">{{ lang.en }} [{{Data.ph_en}}]</span><i class="dic-sound" @click="sound(Data.ph_en_mp3,'ph_en')"></i>
                </span>
                <span v-if="Data.ph_am_mp3">
                  <span class="word_ph">{{ lang.american }} [{{Data.ph_am}}]</span><i class="dic-sound" @click="sound(Data.ph_am_mp3,'ph_am')"></i>
                </span>
              </div>
              <!-- 逻辑：如果英美发音都没有的时候 用CEJ录入的发音cej_ph_en-->
              <div v-else-if="Data.cej_ph_en">
                <span>
                  <span class="word_ph">{{Data.word_name}}</span><i class="dic-sound" @click="sound(Data.cej_ph_en,'ph_en')"></i>
                </span>
              </div>
 
              <div v-if="Data.meaning_of_kid && Data.meaning_of_kid['0']=='null'  || !Data.meaning_of_kid ">
                <p v-for="part in Data.meaning0">
                  <span>{{part.part}} </span>
                  <span v-for="me in part.means" v-text="me+';'"></span>
                </p>
              </div>

              <div v-else class="section-p">
                <div class="collins-section" v-for="(value,key,index) in  Data.meaning_of_kid">
                  <i class="prep-order-icon" v-text="index+1"></i>
                  <span>{{ value }}</span>
                </div>
              </div>

             </p>
           </div>
         </div>
        </div>

        <div id="resource">
          <div v-if="level == '-1' && Data.cover_picture_link_levelk !=''" class="resource resource_book" >
            <p><span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>{{ lang.day_word }}</strong></span>
            </p>
             <!-- 20210316 新增levelk的每日一词图片替换-->
            <div class="resource-content intro" >
              <img class="daily_word_img" :src="Data.cover_picture_link_levelk">
              <p>{{ lang.listen }}</p>
              <audio id="media_link" class="audio_dailyword" controls="controls" :src="Data.media_link_levelk">
               {{ lang.audio_tips }}
               </audio>
            </div>
          </div>

          <div v-else-if="Data.cover_picture_link" class="resource resource_book" >
            <p><span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>{{ lang.day_word }}</strong></span>
            </p>

            <div class="resource-content intro" >
              <img class="daily_word_img" :src="Data.cover_picture_link">
              <p>{{ lang.teacher }}</p>
              <audio id="media_link" class="audio_dailyword" controls="controls" :src="Data.media_link">
               {{ lang.audio_tips }}
               </audio>
            </div>
          </div>

          <div class="resource resource_cartoon" v-if="Data.sentence_of_kid">
           <!-- 20210224 全部删除 Data.sentence0 外部有道爬取的数据-->
            <p > 
              <span class="resource-title">
                <span class="fa fa-star"></span>
                <strong>{{ lang.two_language }}:</strong>
              </span>
            </p>

            <!-- <div v-if="Data.sentence_of_kid['null'] || !Data.sentence_of_kid">
              <div class="resource-content intro">
                <div class="article-section">
                  <div class="section-p">
                    <div class="p-container" v-for="(item,index) in Data.sentence0">
                      <p class="p-english family-english size-english">
                        <span class="p-order">{{index+1}}.</span>
                        <span v-html="highlight(item.Network_en)"></span>
                        <i class="dic-sound" @click.stop.prevent="sound(item.tts_mp3,'sentence_youdao')"></i>
                      </p>
                      <p class="p-chinese family-chinese size-chinese" style="color: RGB(27, 70, 125)" v-text="item.Network_cn"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            
            <div class="resource-content intro">
              <div class="article-section">
                <div class="section-p">
                  <div class="collins-section" v-for="(item,key,index) in Data.sentence_of_kid">
                    <i class="prep-order-icon" v-text="index+1"></i>
                    <!-- word each meaning -->
                    <span v-text="key"></span>
                    <div class="p-container" v-for="(item,key,index) in item">
                      <!-- example sentence for each word meaning -->
                      <p class="p-english family-english size-english">
                        <span class="p-order">{{index+1}}.</span>
                        <span v-html="highlight(item.e_sentence)"></span>
                        <i class="dic-sound" @click.stop.prevent="sound(CEJmp3add(item.sentence_url),'sentence')"></i>
                      </p>
                      <p class="p-chinese family-chinese size-chinese" style="color: RGB(27, 70, 125)" v-text="item.c_sentence"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>

      </div>
      </div>
    </div>
 </div>
</template>

<script>
require('@/assets/css/peasonalized-target.css')
import 'font-awesome/css/font-awesome.css'
import BaseVue from '@/components/BaseVue'

export default {
  name: 'WordTemplateV2',
  extends: BaseVue,
  /* inherit from BaseVue,the para in data can call on above */
  data() {
    return {
      Data: {
        tips: '',
        user_id: '',
        word_name: "",
        meaning_of_kid: {0: '',1: ''},
        ph_en: "",
        ph_am: "",
        ph_en_mp3: "",
        ph_am_mp3: "",
        cej_ph_en: "",
        sentence_of_kid: '',
        level: '',
        // sentence0: [
        //           {
        //           Network_en: "There is a chance of sunny spells in the West.",
        //           Network_cn: "西部可能会有一段天气晴朗的日子。",
        //           tts_mp3: "http://res-tts.iciba.com/tts_new_dj//9/a/5/9a5e024d941e5d3715772c273adf9b80.mp3"
        //           },
        //           {
        //           Network_en: "Stand the plant in the open in a sunny, sheltered place.",
        //           Network_cn: "把这株植物放在一个阳光充足、上方有遮盖物的开阔处。",
        //           tts_mp3: "http://res-tts.iciba.com/tts_new_dj//8/4/c/84c8da1a4947b8b9d81e9b8519945d13.mp3"
        //           },
        //           {
        //           Network_en: "He was a nice lad — bright and with a sunny disposition.",
        //           Network_cn: "他是个不错的小伙子——聪明伶俐而且性格开朗。",
        //           tts_mp3: "http://res-tts.iciba.com/tts_new_dj//a/5/d/a5df775b0483955c941119476748d23d.mp3"
        //           }
        //           ]
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function (){
    await this.getLang()
    document.title = this.lang.WordTemplateV2Title
    let data_id = this.$route.params.id
    this.user_id = this.$route.query.uid
    //20210316 @wanfeng 单元知识针对levelk的部分每日一词进行替换
    this.level = this.$route.query.level
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_word?id=' + data_id
    // let url= this.APIHOST + 'word/' + data_id +'?cipher=0&format=json'
    //uid=86923540938&unit_type=now&adminid=123
    this.url_params = this.$route.fullPath.split('?')[1]
    let that = this;
    /* queryData from basevue */
    this.queryData(url, function(data) {
      if (data.sentence_of_kid && data.sentence_of_kid != '{}' && data.sentence_of_kid != ''){
        data['sentence_of_kid'] = JSON.parse(data['sentence_of_kid'])
      }
      else{
        data['sentence_of_kid'] = ''
      }
      // console.log('sentence of kid：'+ data['sentence_of_kid'])
      if (data['meaning_of_kid']) data['meaning_of_kid'] = JSON.parse(data['meaning_of_kid'])
      that.Data = data
      //未返回准确数据的时候反馈的数据是空字典，赋值给tips展现温馨提示
      if(JSON.stringify(data) == '{}'){
        console.log('data is {}:')
        that.Data.word_name = 'Word Lost'
        that.Data.tips= this.lang.data_tips1
      }
      // console.log('tips finally')
      // console.log(that.Data.tips)
    })
    // 增加单词页面埋点
    pindData.add_params({"t":"wl.000001"});
    let value = '{"t":"wl.000001","v":{"action":"PG_WORD_LEARNING","name":'+ this.word_name + ',"userid":' + this.user_id + '}}'
    __sdonclick(value);
  },
  methods: {
    changeFontSize: function(){
      if (window.innerWidth >500) return 20
      return  parseInt(375 / (18+ Data.word_name.length + 2))
    },
    sound: function(url,type){
      var audio= new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
      // type记录学员听了当前单词的美音(ph_am)、英音(ph_en)、有道的例句(sentence_youdao)、青少课前的例句(sentence)
      // 单词本过来的uid是加密的，单元知识过来的uid是解密的，点击流中需要解析
      pindData.pind_send( {"action": "CK_WORD_LEARNING_SOUND", "name": this.word_name,"userid": this.user_id, "type": type} );
    },
    trimRegExp: function(e) {
        return e.replace(/([\.\?\+\*\^\(\)\\\{\}\$\/])/g, "\\$1")
      },
    // 句子中出现单词部分加粗
    highlight: function(e){
      var word = this.Data.word_name
      return e.replace(word,"<b style='color: orange'> "+ word + "</b>")
    },
    //不同词性下的编号改为大写字母
    numToLetter: function(e){
      return String.fromCharCode(65 + parseInt(e))
    },
    //添加例句发音的首部地址
    CEJmp3add: function(e){
      return 'http://www.51talkjr.com/upload/efl_audio/prepar/'+e
    },
  },
  filters: {
    trimRegExp: function(e){
        return e.replace(/([\.\?\+\*\^\(\)\\\{\}\$\/])/g, "\\$1")
      },
 }
}
</script>



// WEBPACK FOOTER //
// src/components/resource/WordV2.vue